import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, MapPin, Clock, Users, Star, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function EventPage() {
  const { id } = useParams<{ id: string }>();
  
  // TODO: Fetch event data
  
  return (
    <div className="min-h-screen pb-24">
      {/* Header with back button */}
      <header className="sticky top-0 z-10 border-b bg-background/95 px-4 py-3 backdrop-blur supports-[backdrop-filter]:bg-background/80">
        <div className="mx-auto flex max-w-lg items-center gap-3">
          <Link to="/buscar" className="rounded-lg p-2 hover:bg-accent">
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <h1 className="font-display text-lg font-semibold">Detalhes do Evento</h1>
        </div>
      </header>
      
      <main className="mx-auto max-w-lg px-4 py-6">
        {/* Placeholder content */}
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-12 text-center">
            <p className="text-muted-foreground">
              Evento não encontrado ou ainda não implementado.
            </p>
            <p className="mt-2 text-sm text-muted-foreground">
              ID: {id}
            </p>
            <Button asChild variant="link" className="mt-4">
              <Link to="/buscar">Voltar para busca</Link>
            </Button>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}

